import { Field, Input, Textarea } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { Khoi, type TabProps } from './chung';

export function TabTongQuan({ f, dat, suaDuoc }: TabProps) {
  const { t } = useT();
  return (
    <Khoi ten={t('troLyAiBot.mucCoBan')}>
      <Field label={t('troLyAiBot.tenChatbot')} required>
        {(p) => (
          <Input
            {...p}
            disabled={!suaDuoc}
            value={f.name}
            onChange={(e) => dat('name', e.target.value)}
            placeholder={t('troLyAiBotViDu.botTen')}
          />
        )}
      </Field>
      <Field label={t('troLyAiBot.moTaNgan')}>
        {(p) => (
          <Input
            {...p}
            disabled={!suaDuoc}
            value={f.shortDescription}
            onChange={(e) => dat('shortDescription', e.target.value)}
            placeholder={t('troLyAiBotViDu.botMoTa')}
          />
        )}
      </Field>
      {/*
        Lời chào nằm ở mục Cơ bản, không ở mục Khung nhúng: màn "Trò chuyện với bot" cũng vẽ đúng trường này ở lượt mở đầu.
        Ô NHIỀU DÒNG vì lời chào thường có xuống dòng — một câu chào rồi mấy chủ đề gợi ý.
      */}
      <Field label={t('troLyAiBot.loiChao')}>
        {(p) => (
          <Textarea
            {...p}
            autoSize={{ minRows: 2, maxRows: 6 }}
            disabled={!suaDuoc}
            value={f.widget.greeting}
            onChange={(e) => dat('widget', { ...f.widget, greeting: e.target.value })}
            placeholder={t('troLyAiBotViDu.khungLoiChao')}
          />
        )}
      </Field>
      <Field label={t('troLyAiBot.mucDich')}>
        {(p) => (
          <Textarea
            {...p}
            autoSize={{ minRows: 2, maxRows: 6 }}
            disabled={!suaDuoc}
            value={f.purpose}
            onChange={(e) => dat('purpose', e.target.value)}
            placeholder={t('troLyAiBotViDu.botMucDich')}
          />
        )}
      </Field>
    </Khoi>
  );
}
